export default __webpack_public_path__ + "static/media/3.28fb9285.jpg";